import { useState, useEffect } from 'react';
import Body from './Body';
import { loadStripe } from '@stripe/stripe-js';
import { useDispatch } from 'react-redux';
import { loadingStart, loadingStop } from 'redux/action';
import API from 'services/api';
import { toast } from 'react-toastify';

export const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

const Index = () => {
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [clientSecret, setClientSecret] = useState(null);

  const [form, setForm] = useState({
    company: '',
    primaryPerson: { name: '', phone: '', email: '' },
    isAttending: 'yes',
    totalPersons: 1,
    address: '',
    city: '',
    state: '',
    zip: '',
    additionalPersons: []
  });

  useEffect(() => {
    const extraCount = form.isAttending === 'yes' ? form.totalPersons - 1 : form.totalPersons;

    setForm((prev) => ({
      ...prev,
      additionalPersons: Array.from(
        { length: Math.max(extraCount, 0) },
        (_, i) => prev.additionalPersons[i] || { name: '', phone: '', email: '' }
      )
    }));
  }, [form.totalPersons, form.isAttending]);

  // ---------------- VALIDATION ----------------
  const validateStep1 = () => {
    if (!form.company.trim()) return false;

    const { name, phone, email } = form.primaryPerson;
    if (!name || !phone || !/\S+@\S+\.\S+/.test(email)) return false;

    for (const p of form.additionalPersons) {
      if (!p.name || !p.phone || !/\S+@\S+\.\S+/.test(p.email)) return false;
    }

    return true;
  };

  const totalAmount = form.totalPersons * 595;

  const createPaymentIntentForVegasConferenceFranchise = async () => {
    dispatch(loadingStart());

    try {
      const response = await API.createPaymentIntentForVegasConferenceFranchise({
        ...form,
        amount: totalAmount * 100
      });

      if (!response.clientSecret) {
        toast.error('Payment intent creation failed');
        setStep(2);
      } else {
        setClientSecret(response.clientSecret);
      }
    } catch (error) {
      toast.error('Payment intent error');
      setStep(2);
    } finally {
      dispatch(loadingStop());
    }
  };

  // Create intent when entering payment step
  useEffect(() => {
    if (step === 2 && validateStep1() && !clientSecret) {
      createPaymentIntentForVegasConferenceFranchise();
    }
  }, [step]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [step]);

  return (
    <Body
      _this={{
        step,
        setStep,
        form,
        setForm,
        clientSecret,
        stripePromise,
        validateStep1,
        totalAmount
      }}
    />
  );
};

export default Index;
